import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'dvl-delete-confirm',
  templateUrl: './delete-confirm.component.html'
})
export class DvlDeleteConfirmComponent {
  @Input() food: any;
  @Output('reject') rejectEmitter: EventEmitter<void>;
  @Output('confirm') confirmEmitter: EventEmitter<any>;

  constructor() {
    this.rejectEmitter = new EventEmitter<void>();
    this.confirmEmitter = new EventEmitter<any>();
  }

  reject(): void {
    this.rejectEmitter.emit();
  }

  confirm(): void {
    this.confirmEmitter.emit();
  }
}



// WEBPACK FOOTER //
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/app/reception/components/attendee-form/components/delete-confirm/delete-confirm.component.ts